import React from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {Icon} from '@components/common/base/icon'
import {Tooltip} from '@components/common/tooltip/tooltip'
import {getDeadlineStatus} from './get-deadline-status'
import {AggregatedDeadlineProps} from './types'

const TwAggregatedDeadline = tw.div<{$colored?: boolean; $status?: string}>`
  flex-none
  flex
  items-center
  gap-4
  
  text-xs-regular
  
  ${p => {
    if (!p.$colored) {
      return 'text-secondary'
    }

    // todo: check these color later
    switch (p.$status) {
      case 'expired':
        return 'text-status-error'
      case 'completed':
        return 'text-secondary'
      default:
        return 'text-secondary'
    }
  }}
`

export const AggregatedDeadline = (props: AggregatedDeadlineProps) => {
  const {status, date} = props.status ?? getDeadlineStatus(props)

  return date ? (
    <Tooltip content={Lang.msg.subtask.deadline} placement="bottom-start">
      <TwAggregatedDeadline $status={status} $colored={props.colored}>
        <Icon icon="IconCustomStopwatch" size={16} />
        <div>{date}</div>
      </TwAggregatedDeadline>
    </Tooltip>
  ) : null
}
